import { Box, Typography } from "@mui/material";
import React, { FC } from "react";
import { sortBy } from "lodash";
import moment from "moment";

import { IUptimeChartData } from ".";

interface IUptimeChartProps {
	data: IUptimeChartData;
}

const timeArray = [
	"12:00 AM",
	"01:00 AM",
	"02:00 AM",
	"03:00 AM",
	"04:00 AM",
	"05:00 AM",
	"06:00 AM",
	"07:00 AM",
	"08:00 AM",
	"09:00 AM",
	"10:00 AM",
	"11:00 AM",
	"12:00 PM",
	"01:00 PM",
	"02:00 PM",
	"03:00 PM",
	"04:00 PM",
	"05:00 PM",
	"06:00 PM",
	"07:00 PM",
	"08:00 PM",
	"09:00 PM",
	"10:00 PM",
	"11:00 PM"
];

const UptimeChart: FC<IUptimeChartProps> = (props) => {
	const { data } = props;

	return (
		<Box sx={{ position: "relative", height: "375px", display: "flex", flexDirection: "column" }}>
			<Box className="uptime-table-legend-wrapper">
				<Box className="uptime-legend-item">
					<Box className="uptime-legend-item-icon online" />

					<Typography variant="body2">System Up</Typography>
				</Box>

				<Box className="uptime-legend-item">
					<Box className="uptime-legend-item-icon offline" />

					<Typography variant="body2">System Down</Typography>
				</Box>
			</Box>

			<Box className="uptime-table-wrapper">
				<Box className="uptime-table-column-wrapper">
					<Box className="uptime-table-row-cell"></Box>

					<Box className="uptime-table-row-cell">
						<Typography variant="caption">Time</Typography>
					</Box>

					{timeArray.map((time, index) => (
						<Box className="uptime-table-row-cell" key={index}>
							<Typography variant="caption">{time}</Typography>
						</Box>
					))}
				</Box>

				{sortBy(Object.keys(data)).map((date) => {
					const uptimeList = sortBy(data[date], "start_time");

					return (
						<Box className="uptime-table-column-wrapper" key={date}>
							<Box className="uptime-table-row-cell">
								<Typography variant="caption">{moment(date).format("DD/MM/YYYY")}</Typography>
							</Box>

							<Box className="uptime-table-row-cell">
								<Typography variant="caption">{moment(date).format("ddd")}</Typography>
							</Box>

							{uptimeList.length > 0 ? (
								<>
									{uptimeList.map((uptimeItem, index) => (
										<Box
											key={index}
											className={`uptime-table-row-cell graph ${uptimeItem.is_online ? "online" : "offline"}`}
											sx={{ height: `${(timeArray.length * 25 * uptimeItem.duration) / (timeArray.length * 60)}px` }}
										/>
									))}

									{moment(uptimeList[uptimeList.length - 1].end_time).format("HH:mm") !== "23:59" ? (
										<Box className="uptime-table-row-cell graph rest" />
									) : null}
								</>
							) : (
								<Box className="uptime-table-row-cell graph rest" />
							)}
						</Box>
					);
				})}
			</Box>
		</Box>
	);
};

export default UptimeChart;
